module.exports = __webpack_public_path__ + "img/lacrosse_w.755b862f.svg";